import * as styles from "./DialogFooter.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { DialogFooterProps } from "./Dialog.types";

export function DialogFooter({
  className,
  ...props
}: DialogFooterProps): JSX.Element {
  return (
    <div
      data-slot="dialog-footer"
      className={clsx(styles.footer, className)}
      {...props}
    />
  );
}
